"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolbarMenuButton = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _core = require("@material-ui/core");
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = _interopRequireWildcard(require("react"));
var _useTheme = require("../../../theme/utils/useTheme");
var _useHovered = require("../../../util/useHovered");
var _menu = require("../../menu");
var _useFocusElement = require("../hooks/useFocusElement");
var _toolbarTheme = require("../styled/toolbarTheme");
var _ToolbarButtonBase = require("./ToolbarButtonBase");
const ToolbarMenuButton = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    children,
    label,
    id: providedId,
    isChecked,
    menuHasContentBefore,
    menuId: providedMenuId,
    menuRef,
    menuPlacement = "bottom",
    onKeyDown: providedOnKeyDown,
    menuZIndex,
    width,
    maxWidth,
    textAlign,
    isTooltipVisualOnly,
    omitContentAfter = false,
    ...rest
  } = _ref;
  const localMenuRef = (0, _react.useRef)(null);
  const internalMenuRef = (0, _lodestarUtils.useForkRef)(localMenuRef, menuRef);
  const {
    isOpen,
    onCloseRequested,
    onOpenRequested
  } = (0, _menu.useMenuOpenState)();
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const localKeyDown = (0, _react.useCallback)(evt => {
    switch (evt.key) {
      case "ArrowRight":
      case "ArrowLeft":
      case "Tab":
        onCloseRequested();
        break;
    }
    providedOnKeyDown?.(evt);
  }, [onCloseRequested, providedOnKeyDown]);
  const buttonId = (0, _react.useMemo)(() => providedId ?? (0, _lodestarUtils.genId)("tbmb-root"), [providedId]);
  const menuId = (0, _react.useMemo)(() => providedMenuId ?? (0, _lodestarUtils.genId)("tbmb-menu"), [providedMenuId]);
  const focusProps = (0, _useFocusElement.useFocusElement)({
    targetRef: ref,
    onFocus: rest.onFocus,
    onKeyDown: localKeyDown,
    onBlur: rest.onBlur
  });
  const {
    isHovered,
    onMouseEnter,
    onMouseLeave
  } = (0, _useHovered.useHovered)({
    onMouseEnter: rest.onMouseEnter,
    onMouseLeave: rest.onMouseLeave
  });
  const {
    getMenuProps,
    getTargetHTMLProps
  } = (0, _menu.useMenu)({
    style: {
      maxHeight: "40vh"
    },
    onCloseRequested,
    isOpen,
    onOpenRequested,
    targetRef: focusProps.ref,
    placement: menuPlacement,
    id: menuId,
    menuRef: internalMenuRef
  });
  const targetMenuProps = getTargetHTMLProps({
    ...rest,
    onKeyDown: focusProps.onKeyDown,
    tabIndex: focusProps.tabIndex,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onBlur: focusProps.onBlur,
    onFocus: focusProps.onFocus,
    "aria-label": label
  });
  return /*#__PURE__*/_react.default.createElement(_core.ClickAwayListener, {
    onClickAway: () => onCloseRequested()
  }, /*#__PURE__*/_react.default.createElement("div", {
    role: "presentation"
  }, /*#__PURE__*/_react.default.createElement(_ToolbarButtonBase.ToolbarButtonBase, (0, _extends2.default)({}, rest, {
    label: label,
    isChecked: Boolean(isChecked),
    isOpen: isOpen,
    isHovered: isHovered,
    iconAfter: omitContentAfter ? undefined : (0, _toolbarTheme.getToolbarDropdownArrowIconTheme)(themeMode),
    toolbarButtonType: "ToolbarMenuButton",
    id: buttonId,
    width: width,
    maxWidth: maxWidth,
    textAlign: textAlign,
    tooltipVisualOnly: isTooltipVisualOnly
  }, targetMenuProps, {
    tabIndex: rest.tabIndex === 0 ? rest.tabIndex : targetMenuProps.tabIndex
  })), /*#__PURE__*/_react.default.createElement(_menu.Menu, getMenuProps({
    "aria-label": label,
    offset: {
      distance: 4
    },
    portalProps: menuZIndex ? {
      zIndex: menuZIndex
    } : undefined,
    hasContentBefore: menuHasContentBefore
  }), children)));
});
exports.ToolbarMenuButton = ToolbarMenuButton;
ToolbarMenuButton.displayName = "ToolbarMenuButton";
//# sourceMappingURL=ToolbarMenuButton.js.map